import { ApontamentoGridPage } from './apontamentos/ApontamentoGridPage';

/**
 * `/operacao/financeiro/apontamentos` — visão única (Grid). Wizard e
 * calendário foram descontinuados no protótipo; a rota base renderiza
 * direto a grade.
 */
export function ApontamentosPage() {
  return <ApontamentoGridPage />;
}

export default ApontamentosPage;
